<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="460">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="100">

            <Row>
                <Col span="12">
                    <FormItem label="检测单位" prop="department.id" :rules="[rules.requiredNumber]">
                        <depart-sel v-model="formData.department.id" :departmentType="1" width="200px" placeholder="请选择检测单位"></depart-sel>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="检测人员" prop="tester.id">
                        <tester-sel v-model="formData.tester.id" :departmentId="formData.department.id" :withoutDepart="false" width="200px" placeholder="请选择检测人员"></tester-sel>
                    </FormItem>
                </Col>
            </Row>

            <FormItem label="设备类型" prop="dataType" :rules="[rules.requiredNumber]">
                <Select v-model="formData.dataType" placeholder="设备类型" style="width:200px;" clearable="">
                    <!--<Option :value="1">烟度计</Option>
                    <Option :value="2">计时器</Option>
                    <Option :value="3">震动转速分析仪</Option>
                    <Option :value="4">滤光片</Option>-->
                    <Option v-for="(item,index) in typeArr" :value="item.value" :key="index">{{item.label}}</Option>
                </Select>
            </FormItem>

            <FormItem label="通信方式" prop="communicationMode" :rules="[rules.requiredNumber]">
                <Select v-model="formData.communicationMode" placeholder="通信方式" style="width:200px;" clearable="">
                    <Option :value="1">串口</Option>
                    <Option :value="2">蓝牙</Option>
                    <Option :value="3">WIFI</Option>
                </Select>
            </FormItem>

            <FormItem label="型号" prop="instrumentType" :rules="[rules.required]">
                <Input v-model="formData.instrumentType"></Input>
            </FormItem>
            <FormItem label="编号" prop="instrumentNo" :rules="[rules.required]">
                <Input v-model="formData.instrumentNo"></Input>
            </FormItem>
            <FormItem label="厂家" prop="instrumentManu" :rules="[rules.required]">
                <Input v-model="formData.instrumentManu"></Input>
            </FormItem>
            <FormItem label="计量证书" prop="cmaNo">
                <Input v-model="formData.cmaNo"></Input>
            </FormItem>
            <FormItem label="校准截止日期" prop="calibrationUtilDate" :rules="[rules.required]">
                <DatePicker type="date" placeholder="校准截止日期" format="yyyy-MM-dd" :value="formData.calibrationUtilDate" @on-change="dateChange"></DatePicker>
            </FormItem>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit">确定</Button>
        </div>
    </Modal>
</template>

<script>
    import iExam from '@/module/main/api/iExam'
    import rules from '@/libs/rules';
    import modalHelper from "@/mixins/modalHelper";
    import DepartSel from '@/module/main/components/DepartSel';
    import TesterSel from '@/module/main/components/TesterSel';
    import _don from "@/libs/doson";
    import {instrumentType} from "@/config/config"

    const formModal = {
        id:null,
        department:{id:0},
        dataType:null,
        instrumentType:null,
        instrumentNo:null,
        instrumentManu:null,
        communicationMode: 1,
        cmaNo:null,
        calibrationUtilDate:null,
        tester:{id:null},
        addTime:null
    };

    export default {
        name: "instrument-edit",
        mixins: [modalHelper],
        components: {
            DepartSel,TesterSel
        },
        data() {
            return {
                rules,
                formData: _don.cloneWithModal(formModal),
                region: [],
                upOption:{uploadMaxCount:3},
                typeArr:instrumentType
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
            },
            async handleSubmit() {
                if (!await this.$refs.form.validate()) return;
                // 提交
                if (this.formData.id) {
                    iExam.instrumentUpdate(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                } else {
                    iExam.instrumentAdd(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                }
            },
            dateChange(v) {
                this.formData.calibrationUtilDate = v
            }
        },
        computed: {
            title() {
                return '检测设备' + (this.formData.id?'编辑':'添加');
            }
        },
        watch:{

        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
